export const environment = {
    production: false,
    apiUrl: window["env"]["apiUrl"] || "default",
  };